<div class="page-padding">

    <mat-card>
        <div class="panel__header">
            <span class="panel__header__title">  {{'Search O/S UC Action Recommendations' | translate | async}}</span>
        </div>
        <div class="row">
            <div class="panel__header__buttons" style="display: flex; float:inline-end">
                <div *ngFor="let favorite of userFavorites" class="favourites" style="margin-left:9px">
                    <a class="button button--hover-icon" [ngStyle]="{'background-color':favorite.BackgroundColor}">
                        <span class="button__text" [ngStyle]="{'color':favorite.TextColor}"
                            (click)="getFavorite(favorite.Id)">{{favorite.Name}}</span>

                    </a>
                </div>
                <div class="divider"></div>
                <a style="margin-top: 6px;">
                    <span style="    font-size: 18px;
                    color: black;
                    padding: 14px;"> {{'Favorite' | translate | async}}</span>
                </a>
            </div>
        </div>
        <div class="row ">
            <div class="col-lg-12">

                <mat-form-field class="col-lg-4">
                    <input matInput #customerAutoCompleteInput (focus)="focus(1)" placeholder="{{'Customer' | translate | async}}"
                        aria-label="customer" [matAutocomplete]="autoCustomer" [formControl]="customerCtrl">
                    <mat-autocomplete #autoCustomer="matAutocomplete"
                        (optionSelected)="customerSelected($event,customerAutoCompleteInput )">
                        <mat-option *ngFor="let customer of filteredCustomers | async" [value]="customer">
                            <span>{{ customer.Title }}</span>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field class="col-lg-4">

                    <input matInput (focus)="focus(2)" #jobSiteAutoCompleteInput placeholder=" {{'Jobsite' | translate | async}}"
                        aria-label="jobsite" [matAutocomplete]="autoJobsite" [formControl]="jobsiteCtrl">

                    <!-- [displayWith]="jobsiteDisplayMapper" -->
                    <mat-autocomplete #autoJobsite="matAutocomplete"
                        (optionSelected)="jobsiteSelected($event, jobSiteAutoCompleteInput)">
                        <mat-option *ngFor="let jobsite of filteredJobsites | async" [value]="jobsite">
                            <!--<img style="vertical-align:middle;" aria-hidden src="" height="25" />-->
                            <span>{{ jobsite.Title }}</span>
                            <small></small>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field class="col-lg-4">

                    <input matInput (focus)="focus(4)" #familyAutoCompleteInput placeholder="{{'Family' | translate | async}}"
                        aria-label="Family" [matAutocomplete]="autoFamily" [formControl]="familyCtrl">

                    <mat-autocomplete #autoFamily="matAutocomplete"
                        (optionSelected)="familySelected($event,familyAutoCompleteInput)">
                        <mat-option *ngFor="let family of filteredFamilies | async" [value]="family">
                            <span>{{ family.Title }}</span> |
                            <small>{{family.Symbol}}</small>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field class="col-lg-4">

                    <input matInput (focus)="focus(5)" #makeAutoCompleteInput placeholder="{{'Make' | translate | async}}"
                        aria-label="Make" [matAutocomplete]="autoMake" [formControl]="makeCtrl">

                    <mat-autocomplete #autoMake="matAutocomplete"
                        (optionSelected)="makeSelected($event,makeAutoCompleteInput )">
                        <mat-option *ngFor="let make of filteredMakes | async" [value]="make">
                            <span>{{ make.Title }}</span> |
                            <small>{{make.Symbol}}</small>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field class="col-lg-4">
                    <mat-chip-list #modelChipList>
                        <mat-chip class="input-chips" *ngFor="let item of getPushedSelections(6)" [selectable]="false"
                            [removable]="true" (removed)="popMultipleSelection(6, item.SearchId, item.SearchStr)">
                            {{item.Title}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input matInput [matChipInputFor]="modelChipList"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="false"
                            (focus)="focus(6)" #modelAutoCompleteInput placeholder=" {{'Model' | translate | async}}"
                            aria-label="Model" [matAutocomplete]="autoModel" [formControl]="modelCtrl">
                    </mat-chip-list>
                    <mat-autocomplete #autoModel="matAutocomplete" [displayWith]="modelDisplayMapper"
                        (optionSelected)="modelSelected($event,modelAutoCompleteInput)">
                        <mat-option *ngFor="let model of filteredModels | async" [value]="model">
                            <span>{{ model.Title }}</span>
                            <small></small>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field class="col-lg-4">
                    <input matInput placeholder="{{'Equipment Serial No/UnitNo' | translate | async}}" [(ngModel)]="unitAuto">
                </mat-form-field>

            </div>
        </div>


        <div class="row">
            <div class="col-lg-12">
                <mat-form-field class="col-lg-4">
                    <mat-label>{{'Select Status' | translate | async}}<span class="required-label"></span></mat-label>
                    <mat-select name="status" placeholder="{{'Select Status' | translate | async}}"
                        [(ngModel)]="statusId">
                         <ng-container *ngFor="let status of genericIdListTable">
                            <mat-option *ngIf="status.Id != 4" [value]="status.Id">
                                {{ status.Name }}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row">

            <div class="col-lg-12" style="text-align: end;">
                <button mat-raised-button (click)="resetFields()">  {{'Reset' | translate | async}}</button>

                <button mat-raised-button color="warn" (click)="LoadEquipmentRecommenation()"
                    style="margin-left: 20px;margin-right: 20px;">
                     {{'Search' | translate | async}}
                </button>
            </div>
        </div>
    </mat-card>


    <div class="table-row row" style="margin-top: 10px;" *ngIf="IsTableShow">

        <mat-card class="mat-card">
            <div style="text-align: center;margin-left:50%">
                <mat-spinner *ngIf="FleetTableLoader" class=""></mat-spinner>
            </div>
            <!-- Fleet Equipment table -->
            <div class="search-recom">
                <mat-checkbox (change)="OnchangeMainStatus($event)">
                     {{'Select All' | translate | async}}
                </mat-checkbox>

                <mat-form-field appearance="fill">
                    <mat-label>{{ 'Select Status' | translate | async }}<span class="required-label"></span></mat-label>
                    <mat-select placeholder="" [(ngModel)]="StatusIdForMain"
                        name="StatusCheck" (selectionChange)="changeStatus()">
                        <ng-container *ngFor="let status of genericIdListTable">
                            <mat-option *ngIf="status.Id != 4" [value]="status.Id">
                                {{ status.Name }}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
                <button mat-raised-button color="warn" style="margin-left: 20px;margin-right: 20px;"
                    (click)="UpdateActionStatus(0,0,0)">
                     {{ 'Update' | translate | async }}
                </button>

            </div>

            <table class="table table--striped table--full-width" *ngIf="IsTableShow">
                <thead>
                    <tr class="table-row">
                        <th></th>
                        <th> {{'Make' | translate | async}}</th>
                        <th>  {{'Model' | translate | async}}</th>
                        <th>  {{'Unit' | translate | async}}</th>
                        <th> {{'Components' | translate | async}}</th>
                        <th>  {{'Side' | translate | async}}</th>
                        <th>  {{'Position' | translate | async}}</th>
                        <th> {{'Recommended Action' | translate | async}}</th>
                         <th> {{'Summary' | translate | async}}</th>
                        <th> {{'Oldest Date' | translate | async}}</th>
                        <th> {{'Highest Sevrity' | translate | async}}</th>
                        <th> {{'Earliest SMU' | translate | async}}</th>
                        <th> {{'Hours Gained' | translate | async}}</th>
                        <th> {{'Total Cost' | translate | async}}</th>
                        <th> {{'Comment' | translate | async}}</th>
                        <!-- <th>Status<br> Update Date</th> -->
                        <th> {{'Adjust all status for Equip' | translate | async}}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Loop through your items -->
                    <ng-container *ngFor="let item of EquipmentQuoteSummaryVm.Data">
                        <tr class="table-row-style">
                            <td>
                                <a *ngIf="!item.IsExpanded" (click)="toggleExpansion(item,1)" style="cursor: pointer;">
                                    <i class="material-icons square-button__icon">add</i>
                                </a>
                                <a *ngIf="item.IsExpanded" (click)="toggleExpansion(item,1)" style="cursor: pointer;">
                                    <i class="material-icons square-button__icon">remove</i>
                                </a>
                            </td>

                            <td>{{item.Make}}</td>
                            <td>{{item.Model}}</td>
                            <td>{{item.Unit}}</td>
                            <td>{{item.TotalComponent}}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>{{item.ActionCode}}</td>
                            <td>{{item.OldestDate | date:'dd/MM/yyyy'}}</td>
                            <td></td>
                            <td>{{item.Smu}}</td>
                            <td></td>
                            <td>{{item.Cost | currency}}</td>
                            <td>{{item.Comment}}</td>
                            <td></td>
                            <td></td>
                            <!-- <td></td> -->
                        </tr>

                        <ng-container *ngIf="item.IsExpanded">
                            <div style="text-align: center;margin-left:50%">
                                <mat-spinner *ngIf="componentLoader" class=""></mat-spinner>
                            </div>
                            <ng-container *ngFor="let item1 of item.UcPlannerTrackQuoteDetail">
                                <tr>
                                    <td class="mouse_pointer"></td>
                                    <td class="mouse_pointer"
                                        (click)="NavigateTo(item1.ActionDate,item1.TakeAction,item.EquipmentId)">{{
                                        item1.Make }}</td>
                                    <td class="mouse_pointer"
                                        (click)="NavigateTo(item1.ActionDate,item1.TakeAction,item.EquipmentId)">{{
                                        item1.ModelDesc }}</td>
                                    <td class="mouse_pointer"
                                        (click)="NavigateTo(item1.ActionDate,item1.TakeAction,item.EquipmentId)">{{
                                        item1.UnitNo }}</td>
                                    <td class="mouse_pointer"
                                        (click)="NavigateTo(item1.ActionDate,item1.TakeAction,item.EquipmentId)">{{
                                        item1.Component }}</td>
                                    <td class="mouse_pointer"
                                        (click)="NavigateTo(item1.ActionDate,item1.TakeAction,item.EquipmentId)">{{
                                        item1.Side }}</td>
                                    <td class="mouse_pointer"
                                        (click)="NavigateTo(item1.ActionDate,item1.TakeAction,item.EquipmentId)">{{
                                        item1.Pos }}</td>
                                    <td class="mouse_pointer"
                                        (click)="NavigateTo(item1.ActionDate,item1.TakeAction,item.EquipmentId)">{{
                                        item1.ActionDescription }}</td>
                                    <td class="mouse_pointer"
                                        (click)="NavigateTo(item1.ActionDate,item1.TakeAction,item.EquipmentId)">{{
                                        item1.ActionDate | date:'dd/MM/yyyy' }}</td>
                                    <td class="mouse_pointer"
                                        (click)="NavigateTo(item1.ActionDate,item1.TakeAction,item.EquipmentId)">{{
                                        item1.SeverityCategory }}</td>
                                    <td class="mouse_pointer"
                                        (click)="NavigateTo(item1.ActionDate,item1.TakeAction,item.EquipmentId)">{{
                                        item1.TakeAction }}</td>
                                    <td class="mouse_pointer"
                                        (click)="NavigateTo(item1.ActionDate,item1.TakeAction,item.EquipmentId)">{{
                                        item1.HoursGained }}</td>
                                    <td class="mouse_pointer"
                                        (click)="NavigateTo(item1.ActionDate,item1.TakeAction,item.EquipmentId)">{{
                                        item1.Price | currency }}</td>
                                    <td class="mouse_pointer"
                                        (click)="NavigateTo(item1.ActionDate,item1.TakeAction,item.EquipmentId)">{{
                                        item1.Comment}}</td>
                                    <!-- <td class="mouse_pointer">

                                        <mat-form-field style="width: 100%;">
                                            <input matInput [matDatepicker]="picker1" type="picker1"
                                                [(ngModel)]="item1.ModifiedDate" [ngModelOptions]="{standalone: true}"
                                                (dateChange)="DateChange(item1.ModifiedDate,item1.QuoteDetailAuto)">
                                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                            <mat-datepicker #picker1></mat-datepicker>
                                        </mat-form-field>
                                    </td> -->
                                    <td>
                                        <mat-form-field *ngIf="item1.StatusId!=1">
                                            <mat-label>{{'Select Status' | translate | async}}<span class="required-label"></span></mat-label>
                                            <mat-select name="status"
                                                placeholder="{{'Select Status' | translate | async}}"
                                                [(ngModel)]="item1.StatusId"
                                                (selectionChange)="UpdateActionStatus(item1.QuoteDetailAuto, item1.StatusId,1)"
                                                name="{{item1.QuoteDetailAuto}}">

                                                <mat-option *ngFor="let status of genericIdListTable"
                                                    [value]="status.Id">
                                                    {{ status.Name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <span *ngIf="item1.StatusId==1"> Done</span>

                                    </td>
                                    <td>
                                        <div *ngIf="item1.StatusId!=1" style="display: flex;align-items: center;">
                                            <mat-checkbox [checked]="item1.IsChecked">
                                            </mat-checkbox>
                                            <span><mat-icon *ngIf="item1.StatusId==4"
                                                    style="color: green;font-size: 31px;cursor:pointer"
                                                    (click)="ActionDateCheck(item1.ActionDate,item1.TakeAction,item.EquipmentId,1)">east</mat-icon></span>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </tbody>
            </table>
        </mat-card>
    </div>
</div>


<div class="popup-overlay" *ngIf="isPopupOpen">
  <div class="popup-box">
    <div style="display: flex;justify-content: space-between; align-items: center;">
    <h3> {{'Message' | translate | async}}</h3>
     <i class="material-icons ttmodal__close-button" (click)="closePopup()" matTooltip="Close">close</i>
    </div>
    <p style="font-size:14px">{{'Action Recommendation date is a future Date, which is not permissible in the Action Taken Screen, the system will use the current Date and Hour meter, please adjust accordingly' | translate | async}}</p>
   <div class="ttmodal__footer">
      <button mat-raised-button (click)="closePopup()">Cancel</button>
      <button mat-raised-button color="warn"  (click)="NavigateTo(actionDate,smu,equipemntId,flag)" >
        {{'Continue' | translate | async}}
      </button>
  </div>
</div>
